import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MenuItem, Typography } from "@mui/material";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../routes/routeName";
import {
  ButtonBack,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../components/alert/swal";
import { calculateLeavePeriod } from "../../../utils/calculatePeriod";
import { OnlineLeaveSubmissionApi } from "../../../api/online-leave-submission/online-leave-submission.api";
import UploadFile from "../../../components/upload/UploadFile";
import InputTextField from "../../../components/input/inputTextField";
import FilterSelect from "../../../components/select/filterSelect";
import { leaveTypeApi } from "../../../api/leave-type/leave-type.api";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import moment from "moment";
import InputDatePicker from "../../../components/input/inputDatePicker";
import Form01 from "./form-submission/form/Form01";
import generateForm01 from "./form-submission/data/form01.data";
import generateForm02 from "./form-submission/data/form02.data";
import Form02 from "./form-submission/form/Form02";
import Form03 from "./form-submission/form/Form03";
import generateForm03 from "./form-submission/data/form03.data";
import Form04 from "./form-submission/form/Form04";
import Form05 from "./form-submission/form/Form05";
import generateForm04 from "./form-submission/data/form04.data";
import generateForm05 from "./form-submission/data/form05.data";
import Form07 from "./form-submission/form/Form07";
import generateForm07 from "./form-submission/data/form07.data";
import generateForm11 from "./form-submission/data/form11.data";
import Form11 from "./form-submission/form/Form11";
import generateForm10 from "./form-submission/data/form10.data";
import Form10 from "./form-submission/form/Form10";
import generateForm06 from "./form-submission/data/form06.data";
import Form06 from "./form-submission/form/Form06";
import Form08 from "./form-submission/form/Form08";
import Form09 from "./form-submission/form/Form09";
import { settingLeavePeriodApi } from "../../../api/setting-leave-period/setting-leave-period.api";

type Props = {};

interface LeaveType {
  id_leave_type: number;
  id_leave_form: number;
  leave_type_name: string;
  is_accumulate: string;
  id_employee_inspector: number;
  id_employee_approve: number;
  status: string;
  created_id: number;
  created_date: string;
  modified_id: number;
  modified_date: string;
  leave_form: {
    json: string;
  };
}

const OnlineLeaveSubmissionCreate: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();
  const { profile } = useSelector((state: any) => state.profile);
  const dispatch = useDispatch();

  const [mainInputValue, setMainInputValue] = useState({
    information: {
      id_employee: 0,
      employee_no: "",
      title: "",
      first_name: "",
      last_name: "",
      buddhist_name: "",
      leave_type_id: 0,
      leave_form_id: 0,
      leave_period_id: 0,
      year: 0,
      leave_form_no: "",
      leave_peroid_date: [],
      quit_date: "",
      leave_day: 0,
      worship: "",
    },
  });

  // console.log("mainInputValue", mainInputValue);

  const [dataJson, setDataJson] = useState("");
  
  const [idEmployeeApproveFirst, setIdEmployeeApproveFirst] = useState(0);
  const [idEmployeeApproveSecond, setIdEmployeeApproveSecond] = useState(0);
  const [idEmployeeApproveThird, setIdEmployeeApproveThird] = useState(0);

  const [dataLeaveType, setDataLeaveType] = useState<LeaveType[]>([]);

  const [file, setFile] = useState(null);

  const [isValidateForm, setIsValidateForm] = useState(false);
  const [isValudateFile, setIsValudateFile] = useState(false);

  const getLeaveType = async () => {
    const param = { limit: 100 };
    const res = await leaveTypeApi.getAllLeaveType(param);
    const data = res.data;
    if (data.status < 300) {
      setDataLeaveType(data.data.items);
    } else {
      setDataLeaveType([]);
    }
  };

  const getEmployeeApproveFirst = async () => {
    const res = await OnlineLeaveSubmissionApi.getApproveFirst();
    const data = res.data;
    if (data.status < 300) {
      setIdEmployeeApproveFirst(data.data?.id_employee ?? null);
    } else {
      setIdEmployeeApproveFirst(0);
    }
  };

  useEffect(() => {
    getLeaveType();
    getEmployeeApproveFirst();
  }, []);

  // useEffect(() => {
  //   dispatch(setLoading());
  //   setTimeout(() => {
  //     dispatch(unsetLoading());
  //   }, 500);
  // }, []);

  useEffect(() => {
    const { leave_peroid_date } = mainInputValue.information;

    if (leave_peroid_date && leave_peroid_date.length === 2) {
      const leaveDays = calculateLeavePeriod(
        leave_peroid_date[0],
        leave_peroid_date[1]
      );

      setMainInputValue((prevState) => ({
        information: {
          ...prevState.information,
          leave_day: leaveDays,
        },
      }));
    }
  }, [mainInputValue.information.leave_peroid_date]);

  const validateForm = (formData: any, formConfig: any) => {
    const errors: any = {};

    formConfig.forEach((field: any) => {
      if (field.isRequired && formData[field.section][field.name] === "") {
        errors[field.name] = `${field.label} is required`;
      }
    });

    return errors;
  };

  const handleConfirmSaveLeaveRequest = async (
    dataBody: any,
    fileUpload: any,
    type?: string,
    dataCondition?: any
  ) => {
    alertActive(
      type === "draft" ? "ยืนยันการบันทึกร่าง" : "ยืนยันการลา",
      type === "draft"
        ? "ท่านต้องการบันทึกร่าง ใช่หรือไม่"
        : "ท่านต้องการส่งลา ใช่หรือไม่",
      undefined,
      undefined,
      async () => {
        dispatch(setLoading());

        const dataJson = JSON.stringify(dataCondition);

        const handleBodyApi = {
          id_leave_type: dataBody.information.leave_type_id,
          leave_start_date:
            dataBody.information.leave_peroid_date.length === 2
              ? moment(dataBody.information.leave_peroid_date[0]).format("YYYY-MM-DD")
              : null,
          leave_end_date:
            dataBody.information.leave_peroid_date.length === 2
              ? moment(dataBody.information.leave_peroid_date[1]).format("YYYY-MM-DD")
              : null,
          id_leave_form: dataBody.information.leave_form_id,
          id_leave_period: dataBody.information.leave_period_id,
          year: dataBody.information.year,
          id_employee: dataBody.information.id_employee,
          leave_detail: dataJson,
          leave_status: type,
          leave_approve_first: idEmployeeApproveFirst,
          leave_approve_second: idEmployeeApproveSecond,
          leave_approve_third: idEmployeeApproveThird,
          created_date: new Date(),
          // leave_approve_second: 146,
          // leave_approve_third: 1,
        };

        const formData: FormData = new FormData();

        Object.entries(handleBodyApi).forEach(([key, value]) => {
          formData.append(key, value);
        });

        fileUpload.forEach((file: any) => {
          formData.append("file", file);
        });

        await OnlineLeaveSubmissionApi.createRequestLeaveSubmission(formData)
          .then((res) => {
            if (res.status < 300) {
              if (type === "draft") {
                alertSuccess(
                  "บันทึกร่าง เรียบร้อย",
                  undefined,
                  undefined,
                  () => {
                    navigate(routeName.cms.OnlineLeaveSubmission);
                  }
                );
              } else {
                alertSuccess("ส่งใบลา เรียบร้อย", undefined, undefined, () => {
                  navigate(routeName.cms.OnlineLeaveSubmission);
                });
              }
            }
          })
          .catch((err) => {
            if (type === "draft") {
              alertError("บันทึกร่าง ไม่สำเร็จ", err?.response?.data?.message || "");
            } else {
              alertError("ส่งใบลา ไม่สำเร็จ", err?.response?.data?.message || "");
            }
          })
          .finally(() => {
            dispatch(unsetLoading());
          });
      }
    );
  };

  const handleSubmit = (
    dataBody: any,
    fileUpload: any,
    type?: string,
    dataJson?: any
  ) => {
    // console.log("dataBody", dataBody);
    // console.log("dataJson", dataJson);

    let errors;

    if (mainInputValue.information.leave_form_no === "01") {
      errors = validateForm(mainInputValue, generateForm01);
    } else if (mainInputValue.information.leave_form_no === "02") {
      errors = validateForm(mainInputValue, generateForm02);
    } else if (mainInputValue.information.leave_form_no === "03") {
      errors = validateForm(mainInputValue, generateForm03);
    } else if (mainInputValue.information.leave_form_no === "04") {
      errors = validateForm(mainInputValue, generateForm04);
    } else if (mainInputValue.information.leave_form_no === "05") {
      errors = validateForm(dataJson, generateForm05);
    } else if (mainInputValue.information.leave_form_no === "06") {
      errors = validateForm(mainInputValue, generateForm06);
    } else if (mainInputValue.information.leave_form_no === "07") {
      errors = validateForm(mainInputValue, generateForm07);
    } else if (mainInputValue.information.leave_form_no === "08") {
      errors = validateForm(mainInputValue, generateForm03);
    } else if (mainInputValue.information.leave_form_no === "09") {
      errors = validateForm(mainInputValue, generateForm03);
    } else if (mainInputValue.information.leave_form_no === "10") {
      errors = validateForm(mainInputValue, generateForm10);
    } else if (mainInputValue.information.leave_form_no === "11") {
      errors = validateForm(mainInputValue, generateForm11);
    }
    // console.log("errors", errors);

    if (!fileUpload) {
      setIsValudateFile(true);
      return setIsValidateForm(true);
    }

    if (Object.keys(errors).length > 0) {
      setIsValidateForm(true);
    } else {
      setIsValidateForm(false);
      setIsValudateFile(false);
      handleConfirmSaveLeaveRequest(dataBody, fileUpload, type, dataJson);
    }
  };

  const handleChangePeriodLeave = (value: any) => {
    setMainInputValue({
      information: {
        ...mainInputValue.information,
        leave_peroid_date: value,
      },
    });
  };
  const handleClearPeriodLeave = () => {
    setMainInputValue({
      information: {
        ...mainInputValue.information,
        leave_peroid_date: [],
      },
    });
  };

  const getLeavePeroid = async () => {
    const currentYearBuddhist = new Date().getFullYear() + 543;

    let query: any = {
      leave_period: currentYearBuddhist,
    };
    const res = await settingLeavePeriodApi.getAllLeavePeriod(query);
    const data = res.data;
    if (data.status < 300 && data.data && data.data.items.length > 0) {
      setMainInputValue({
        information: {
          ...mainInputValue.information,
          title: profile.title,
          first_name: profile.first_name,
          last_name: profile.last_name,
          buddhist_name: profile.buddhist_name,
          id_employee: profile.id_employee,
          //
          leave_period_id: data.data.items
            ? data.data.items[0].id_leave_period
            : 0,
          year: data.data.items ? data.data.items[0].leave_period : 0,
        },
      });
    } else {
      setMainInputValue({
        information: {
          ...mainInputValue.information,
          title: profile.title,
          first_name: profile.first_name,
          last_name: profile.last_name,
          buddhist_name: profile.buddhist_name,
          id_employee: profile.id_employee,
        },
      });
    }
  };

  // profile
  useEffect(() => {
    if (profile) {
      getLeavePeroid();
    }
  }, [profile]);

  return (
    <div className="h-auto">
      <NavigateListCustom
        navigateData={[
          {
            name: t(
              "ONLINE_LEAVE_SUBMISSION.COMMON.BREADCRUMB.ONLINE_LEAVE_SUBMISSION_SYSTEM"
            ),
            key: "1",
            pathName: routeName.cms.OnlineLeaveSubmission,
          },
          {
            name: t(
              "ONLINE_LEAVE_SUBMISSION.COMMON.BREADCRUMB.ONLINE_LEAVE_SUBMISSION"
            ),
            key: "2",
            pathName: routeName.cms.OnlineLeaveSubmissionCreate,
          },
        ]}
      />
      {/* header */}
      <section className="my-4">
        <Typography variant="h3">
          {t("ONLINE_LEAVE_SUBMISSION.TOPIC.SUB_ONLINE_LEAVE_SUBMISSION")}
        </Typography>
      </section>

      <section className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-2 md:col-span-6 sm:col-span-12">
          <InputTextField
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.PREFIX_LABEL")}
            value={mainInputValue.information.title ?? ""}
            disabled={true}
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-4 md:col-span-6 sm:col-span-12">
          <InputTextField
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.FIRST_NAME_LABEL")}
            value={mainInputValue.information.first_name ?? ""}
            disabled={true}
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
          <InputTextField
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.LAST_NAME_LABEL")}
            value={mainInputValue.information.last_name ?? ""}
            disabled={true}
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
          <InputTextField
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.NICKNAME_LABEL")}
            value={mainInputValue.information.buddhist_name ?? ""}
            disabled={true}
          />
        </article>
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
          <FilterSelect
            heading={t("ONLINE_LEAVE_SUBMISSION.FORM.LEAVE_TYPE_LABEL")}
            value={mainInputValue.information.leave_type_id}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              const selectedOption = dataLeaveType.find(
                (option: any) =>
                  option.id_leave_type === parseInt(e.target.value)
              );
              if (selectedOption) {
                setIdEmployeeApproveSecond(
                  selectedOption.id_employee_inspector
                );
                setIdEmployeeApproveThird(selectedOption.id_employee_approve);
                const leaveFormNo = selectedOption?.id_leave_form
                  ? selectedOption.id_leave_form < 10
                    ? "0" + selectedOption.id_leave_form.toString()
                    : selectedOption.id_leave_form.toString()
                  : "";
                setMainInputValue({
                  information: {
                    ...mainInputValue.information,
                    leave_type_id: selectedOption?.id_leave_type || 0,
                    leave_form_id: selectedOption?.id_leave_form || 0,
                    leave_form_no: leaveFormNo,
                    leave_peroid_date: [],
                    leave_day: 0,
                    worship: "",
                  },
                });
                setDataJson("");
              }
            }}
            options={dataLeaveType.map((option: any) => (
              <MenuItem value={option.id_leave_type} key={option.id_leave_type}>
                {option.leave_type_name}
              </MenuItem>
            ))}
            labelId={""}
            selectId={""}
          />
        </article>

        {mainInputValue.information.leave_type_id &&
          mainInputValue.information.leave_form_no ? (
          <>
            {mainInputValue.information.leave_form_no === "01" ||
              mainInputValue.information.leave_form_no === "02" ||
              mainInputValue.information.leave_form_no === "03" ||
              mainInputValue.information.leave_form_no === "04" ||
              mainInputValue.information.leave_form_no === "05" ||
              mainInputValue.information.leave_form_no === "06" ? (
              <>
                <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                  <InputNewRangePicker
                    heading={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.PEROID_LEAVE_START_DATE_LABEL"
                    )}
                    value={mainInputValue.information.leave_peroid_date}
                    onchange={handleChangePeriodLeave}
                    onClear={handleClearPeriodLeave}
                    allowClear
                  />
                </article>

                <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                  <InputTextField
                    heading={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.LEAVE_AMOUNT_DATE_LABEL"
                    )}
                    value={mainInputValue.information.leave_day ?? ""}
                    disabled={true}
                  />
                </article>

                <article className="w-full col-span-12 lg:col-span-3 md:col-span-6 sm:col-span-12">
                  <InputTextField
                    heading={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_LABEL"
                    )}
                    placeholder={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_PLACEHOLDER"
                    )}
                    value={mainInputValue.information.worship ?? ""}
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setMainInputValue({
                        information: {
                          ...mainInputValue.information,
                          worship: e.target.value,
                        },
                      })
                    }
                  />
                </article>
              </>
            ) : null}

            {mainInputValue.information.leave_form_no === "07" ? (
              <>
                <article className="w-full col-span-12 lg:col-span-3 md:col-span-12 sm:col-span-12">
                  <InputDatePicker
                    heading={"ขอลาออกตั้งแต่วันที่"}
                    value={mainInputValue.information.quit_date ?? ""}
                    onChange={(e: any) =>
                      setMainInputValue({
                        information: {
                          ...mainInputValue.information,
                          quit_date: moment(e).format("YYYY-MM-DD"),
                        },
                      })
                    }
                  />
                </article>
              </>
            ) : null}

            {mainInputValue.information.leave_form_no === "08" ||
              mainInputValue.information.leave_form_no === "09" ||
              mainInputValue.information.leave_form_no === "10" ||
              mainInputValue.information.leave_form_no === "11" ? (
              <>
                <article className="w-full col-span-12 lg:col-span-9 md:col-span-12 sm:col-span-12">
                  <InputTextField
                    heading={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_LABEL"
                    )}
                    placeholder={t(
                      "ONLINE_LEAVE_SUBMISSION.FORM.DEAR_WORSHIP_PLACEHOLDER"
                    )}
                    value={mainInputValue.information.worship ?? ""}
                    onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setMainInputValue({
                        information: {
                          ...mainInputValue.information,
                          worship: e.target.value,
                        },
                      })
                    }
                  />
                </article>
              </>
            ) : null}
          </>
        ) : null}
      </section>

      <section className="w-full col-span-12 lg:col-span-12 md:col-span-6 sm:col-span-12 mt-4">
        {mainInputValue.information.leave_type_id &&
          mainInputValue.information.leave_form_no ? (
          <>
            {mainInputValue.information.leave_form_no === "01" ? (
              <>
                <Form01
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "02" ? (
              <>
                <Form02
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "03" ? (
              <>
                <Form03
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "04" ? (
              <>
                <Form04
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "05" ? (
              <>
                <Form05
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "06" ? (
              <>
                <Form06
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "07" ? (
              <>
                <Form07
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "08" ? (
              <>
                <Form08
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "09" ? (
              <>
                <Form09
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "10" ? (
              <>
                <Form10
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
            {mainInputValue.information.leave_form_no === "11" ? (
              <>
                <Form11
                  onSubmit={(value) => {
                    console.log("submit", value);
                  }}
                  isValidateForm={isValidateForm}
                  data={dataJson}
                  setData={setDataJson}
                  mainInputValue={mainInputValue}
                  isValudateFile={isValudateFile}
                />
              </>
            ) : null}
          </>
        ) : null}
      </section>

      <section className="w-full mt-10">
        <UploadFile
          helperText={isValudateFile ? "please upload file" : ""}
          onDrop={(file) => {
            setFile(file);
          }}
          file={file}
          onDeleteFile={() => {
            setFile(null);
          }}
          noClick={false}
          customFormat={["image/jpeg", "image/jpg", "image/png"]}
        />
      </section>

      <section className="w-full my-8 flex flex-wrap justify-center items-center gap-4">
        <ButtonBack
          onClick={() => {
            navigate(routeName.cms.OnlineLeaveSubmission);
          }}
          buttonName={t("ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.CANCEL")}
          btnProps={{
            width: "150px",
          }}
        />

        <ButtonPrimary
          onClick={() => {
            handleSubmit(mainInputValue, file, "draft", dataJson);
          }}
          buttonName={t("ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.SAVE_DRAFT")}
          btnProps={{
            bg: "#4198E9",
            width: "150px",
          }}
        />

        <>
          <ButtonPrimary
            onClick={() => {
              handleSubmit(mainInputValue, file, "wait", dataJson);
            }}
            buttonName={t("ONLINE_LEAVE_SUBMISSION.COMMON.BUTTON.CONFIRM")}
            mode="next"
            btnProps={{
              width: "150px",
            }}
          />
        </>
      </section>
    </div>
  );
};

export default OnlineLeaveSubmissionCreate;
